module.exports = Em.Route.extend({
    setupController: function(controller) {
        controller.loadRecords()
    }
})
